<template>
  <div>
    <div class="subtitle1 mb-1">
      {{ $t(`modals.${config.action}.subtitle`) }}
    </div>
    <v-radio-group v-model="localValue.type" hide-details>
      <v-radio
        v-for="choice in [ExportChoice.ALL, ExportChoice.SPECIFIC]"
        :key="choice"
        class="mb-3"
        :value="choice"
        :ripple="false"
        :label="$t(`modals.${config.action}.choices.${choice}`)"
      ></v-radio>
    </v-radio-group>
    <msp-csv-export-modal-filters
      :filter-context="FilterContext.MSP"
      :disable-filters="localValue.type === ExportChoice.ALL"
      @update:filters="localValue.filters = $event"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType, ref, watch } from "vue";
import { type ExportDialogPayload } from "@/_store/exports.module";
import { defaultFiltersState, FilterContext, type MspFilters } from "@/_store/filters.module";
import type { DialogDataConfig } from "@/_store/dialogs.module";
import MspCsvExportModalFilters from "@/components/modals/msp/MspCsvExportModalFilters.vue";
import { MspExportAction } from "@/constants/msp-exports.ts";
import { ExportChoice } from "@/constants/exports.ts";

export default defineComponent({
  components: { MspCsvExportModalFilters },
  props: {
    config: {
      type: Object as PropType<DialogDataConfig>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const localValue = ref<ExportDialogPayload<MspFilters>>({
      type: ExportChoice.ALL,
      filters: {
        ...defaultFiltersState[FilterContext.MSP],
      },
    });

    watch(
      localValue,
      (newVal) => {
        emit("update:localValue", newVal);
      },
      { deep: true, immediate: true }
    );
    return {
      localValue,
      ExportChoice,
      FilterContext,
      MspExportAction,
    };
  },
});
</script>

<style lang="scss" scoped>
:deep(*) {
  .clear-btn {
    display: none !important;
  }
}
</style>
